export default "__VITE_ASSET__6zZmUWjj__"